import { Controller } from "stimulus";

export default class extends Controller {
  static values = { format: Object };

  connect() {
    this.fields = this.getFields();
    this.element.addEventListener("cortana:record_added", (event) => this.calculate(event));
    this.element.addEventListener("cortana:record_destroyed", (event) => this.calculate(event));
    this.element.addEventListener("cortana:record_updated", (event) => this.calculate(event));
    this.calculate();
  }

  getFields() {
    return [...this.element.querySelectorAll("[data-totals-field]")].reduce((map, element) => {
      map.set(element.dataset.totalsField, element);
      return map;
    }, new Map());
  }

  calculate() {
    const totals = [...this.element.querySelectorAll("[data-totals-entry]")].reduce(
      (map, element) => {
        // Element is soft deleted, return 0 for total estimation
        if (element.closest(".list-group-item.d-none")) {
          return map;
        }

        let key = element.dataset.totalsEntry;
        let value = parseFloat(element.value || element.dataset.value);
        if (map.has(key)) {
          map.set(key, map.get(key) + value);
        } else {
          map.set(key, value);
        }

        return map;
      },
      new Map()
    );

    this.fields.forEach((element, key) => {
      const total = totals.get(key) || 0;
      if (this.formatValue) {
        element.innerText = total.toLocaleString("nl-NL", this.formatValue);
      } else {
        element.innerText = total;
      }
    });
  }
}
